import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Литературное чтение. 3-4 классы",
        subject: "Изучение былин как жанра фольклора: трудности и пути их предупреждения",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Изучение былин как жанра фольклора: трудности и пути их предупреждения",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Петрашко Ольга Олеговна",
                grade: "научный сотрудник, заместитель начальника управления научно-организационной деятельности ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<p style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>Для углублённого анализа текста целесообразно использовать произведения разных видов искусства, которые сопровождают текстовую деятельность обучающихся. Ученикам начальных классов особенно трудно представлять портретную характеристику героев, а также воспринимать ритм былинных текстов. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Раскрываются возможности использования изобразительного и музыкального искусства для совершенствования текстовой деятельности младшего школьника, обогащения эмоциональной составляющей урока. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Особое внимание уделяется созданию описаний пейзажа, портрета героя на основе сравнения средств выразительности разных видов и жанров искусств. Визуализация зрительной и слуховой информации при знакомстве с текстом способствует восприятию особенностей сложного ритма произведений фольклора.</p>"
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: `<p>Освоение особенностей такого жанра фольклора как былина вызывает большие трудности у многих младших школьников. </p>
                        <p>Среди них: </p>
                        <p>
                            <ul>
                                <li>отсутствие навыка различения реальных и сказочных героев и событий</li>
                                <li>непонимание специфики ритма и напевности</li>
                                <li>отсутствие рифмы </li>
                            </ul>
                        </p>
                        <p>Цель методического кейса – доказать, что одной из причин этих трудностей является то, что учитель использует традиционные методы текстовой деятельности, которые не могут обеспечить предупреждение ошибок и проблем обучающихся.</p> `
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 5,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Круглов Ю.Г. Вступительная статья к сборнику «Былины». – Москва: Просвещение, 1993",
                "Куприянова Л.Л. Программа «Русский фольклор». 1-4 кл. Факультативный курс. – Москва: Мнемозина, 2000",
                "Лихачев Д. С. Поэтика древнерусской 3-е изд. – Москва: Наука, 1979",
                "Миролюбов Ю.П. Русский языческий фольклор: очерки быта и нравов. – Москва, 1995",
                "Никитина Л.А. Изучение былин в школе в контексте ознакомления с народной культурой / диссертация на соискание учёной степени кандидата педагогических наук. – Самара, 2005",
                "Пропп Я.П.  Русский героический эпос. – Москва: Художественная литература, 1958",
                "Русский фольклор / Сост. и примеч. В.Аникина. – Москва: Художественная литература, 1986"
            ],
            sites: [
                "https://hits.gybka.com/q/гусли+былины/",
                "https://www.culture.ru/events/2945554/russkie-byliny",
                "https://gufo.me/dict/literary_encyclopedia/Былины",
                "https://yunc.org/Былины,_раздел_«Литературовед»",
                "https://hits.gybka.com/q/мусоргский+богатырские+ворота/",
                "https://www.culture.ru/events/3023158/skazki-i-byliny-na-kartinakh-vasnecova",
                "https://www.culture.ru/materials/106153/skazochnyi-mir-viktora-vasnecova",
                "https://www.culture.ru/persons/9346/viktor-vasnecov"
            ],
            filesToDownload: [
                {
                    link: "./files/work.pdf",
                    fileName: "Практическая работа «Моделирование в задачах процентного роста»"
                },
                {
                    link: "./files/examples.pdf",
                    fileName: "Примеры материалов по Информационному моделированию"
                }
            ]
        }
    ],
};
